module.exports = __webpack_public_path__ + "static/media/chart-image.ba90291f.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/images/chart-image.png
// module id = 136
// module chunks = 0